import React, { useState } from "react";
import emailjs from "emailjs-com";

const ContactForm = () => {
  const [form, setForm] = useState({
    nombre: "",
    email: "",
    telefono: "",
    mensaje: "",
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("ENVIANDO");

    const serviceID = "tu_service_id";
    const templateID = "tu_template_id";
    const userID = "tu_user_id"; // Public Key de EmailJS

    emailjs
      .send(serviceID, templateID, form, userID)
      .then((response) => {
        setStatus("ENVIADO");
        setForm({ nombre: "", email: "", telefono: "", mensaje: "" });
      })
      .catch((err) => {
        console.error("Error:", err);
        setStatus("ERROR");
      });
  };

  return (
    


<section className="px-8 xl:px-0"> 
    <form
      className="formulario-contacto fondo-verde blanco"
      onSubmit={handleSubmit}
    >
      <h2>¿NECESITAS AYUDA? ENVIANOS UN MENSAJE</h2>

      <div className="campo column">
        <label className="mayusculas">Nombre</label>
        <input
          type="text"
          name="nombre"
          value={form.nombre}
          onChange={handleChange}
          placeholder="Nombre"
          required
        />
      </div>

      <div className="campo column">
        <label className="mayusculas">Correo electrónico</label>
        <input
          type="email"
          name="email"
          value={form.email}
          onChange={handleChange}
          placeholder="correo@ejemplo.com"
          aria-label="Correo electrónico"
          required
        />
      </div>

      <div className="campo column">
        <label className="mayusculas">Teléfono</label>
        <input
          type="tel"
          name="telefono"
          value={form.telefono}
          onChange={handleChange}
          placeholder="123456789"
          aria-label="Teléfono"
        />
      </div>

      <div className="campo column sobre-mi w-100">
        <label className="mayusculas">Mensaje</label>
        <textarea
          name="mensaje"
          value={form.mensaje}
          onChange={handleChange}
          placeholder="Escribe aquí tu mensaje."
          required
        />
      </div>

      <button type="submit" className="boton" aria-label="Enviar mensaje">
        {status === "ENVIANDO" ? "Enviando..." : "Enviar mensaje"}
      </button>

      {status === "ENVIADO" && (
        <p className="success">¡Mensaje enviado con éxito!</p>
      )}
      {status === "ERROR" && (
        <p className="error">Ocurrió un error, inténtalo de nuevo.</p>
      )}
    </form>
    </section>
  );
};

export default ContactForm;
